module.exports = __webpack_public_path__ + "img/editerArticle.f523d71d.png";